import React from 'react';
import { CompanyLogo } from '../../CompanyLogo';
import { Icon } from '../../../design-system/icons/Icon';
import { getFacetSuggestionIconName } from '../../../utils/search-router/facet-suggestion-icon';
import { SUGGESTIONS_ROW_LEAD, SUGGESTIONS_ROW_LEAD_ICON } from './nav-styles';

/** Leading tile of a suggestion row: the employer's logo for company rows (CompanyLogo's own
 * initials tile covers a missing logo), a facet icon for everything else. Decorative: the
 * attribute caption next to it already names the facet. */
export const SuggestionLead: React.FC<{ attribute: string; value: string }> = ({ attribute, value }) =>
  attribute === 'companyId' ? (
    <CompanyLogo companyName={value} size={32} variant="rounded" loading="lazy" alt="" className="shrink-0" />
  ) : (
    <span className={SUGGESTIONS_ROW_LEAD} aria-hidden>
      <Icon name={getFacetSuggestionIconName(attribute)} useMaskForColor className={SUGGESTIONS_ROW_LEAD_ICON} />
    </span>
  );

